/**
 * Created by renlaydel on 28/11/2017.
 */
import * as apiUtil from '../../apiUtils';
import * as apiCommon from '../../apiCommon';
import { INVENTORY_RETURN } from '../../../constants/constant_doc_types';

export const saveInventoryReturn = async (app, params) => {
  const { data, user = {} } = params;

  let inventoryReturn = {
    id: data.id,
    doc_type: INVENTORY_RETURN,
    restart: data.restart,
    return_type: data.return_type,
    location_id: data.location_id,
    location_type: data.location_type || data.location.location_type.id,
    supplier_id: data.supplier_id,
    subsidiary_id: data.subsidiary_id,
    currency_id: data.currency_id,
    exchange_rate: data.exchange_rate,
    rma: data.rma,
    purchase_receipt_id: data.purchase_receipt_id,
    purchase_order_id: data.purchase_order_id,
    reference_id: data.reference_id,
    status_id: data.status_id,
    status: data.status,
    reference_number: data.reference_number,
    notes: data.notes,
    lines: data.lines,
    tax: data.tax,
    reason_code: data.reason_code_id,
    purchase_contact: data.purchase_contact_id,
    purchase_contact_email: data.purchase_contact_email,
    purchase_contact_number: data.purchase_contact_number,
    transaction_date: apiUtil.toUtcDate(data.transaction_date),
    dispatched_method_id: data.dispatched_method_id,
    dispatched_date: apiUtil.toUtcDate(data.dispatched_date),
    custom_fields: data.custom_fields,
  };

  // const currencyCode = (data.currency || {}).code;

  inventoryReturn.lines = (inventoryReturn.lines || []).map((line) => {
    // line.unit_cost = apiUtil.toCurrency(line.unit_cost, true, currencyCode);
    // line.total = apiUtil.toCurrency(line.total, true, currencyCode);
    // line.total_ex_tax = apiUtil.toCurrency(
    //   line.total_ex_tax,
    //   true,
    //   currencyCode,
    // );

    line.reference_ids = (line.reference_ids || []).map((referenceId) => {
      delete referenceId.onRefLineEditMode;
      delete referenceId.expiry_date;
      return referenceId;
    });
    line.item_id = line.item_id.split(':')[0];
    line.item_type = typeof line.item_type === 'string'
      ? line.item_type
      : line.item_type.id;

    delete line.isFetchingItemLocation;
    delete line.isFetchingTaxGroup;
    delete line.onEditMode;
    return line;
  });

  let url = inventoryReturn.doc_type;
  if (data.process) {
    url = 'inventory_return/process';
  }

  if (data.abandon) {
    url = 'inventory_return/abandon';
  }

  return await apiCommon.saveDoc(
    app,
    {
      source: data,
      doc: inventoryReturn,
      user,
    },
    url,
  );
};

export const fetchInventoryReturnById = (app, params) => {
  const { id } = params;
  return apiCommon.getDoc(
    app,
    { id, docType: INVENTORY_RETURN },
    { assemble_custom_fields: true }
  );
};
